import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";

// userProfileValidation Validation
import * as Yup from "yup";

import withRouter from "../../components/Common/withRouter";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/avatar-1.jpg";
import Select from "react-select";
import {optionMarkupType} from "../../common/data/common";
import {GET_ROLE_TYPE} from "../../store/Global/actiontype";
import {getAllTenantLocationData, getUsersData} from "../../store/Settings/actions";
import {useFormik} from "formik";
import {passwordChangeRequest} from "../../store/auth/forgetpwd/actions";

const UserProfile = props => {

    //meta title
    document.title = "Profile";
    const dispatch = useDispatch();
    const { settings_users_data, tenant_all_location_data } = useSelector((state) => state.settings);
    const { roleData } = useSelector((state) => state.globalReducer);
    const [locations, setLocation] = useState([]);
    const [managerInfo, setManagerInfo] = useState([]);
    const [userDetails, setUserDetails] = useState({});
    const [email, setemail] = useState("");
    const [name, setname] = useState("");
    const [idx, setidx] = useState(1);
    const [passwordShow, setPasswordShow] = useState(false);

    useEffect(() => {
        if (roleData?.length === 0 || roleData === undefined) {
            dispatch({ type: GET_ROLE_TYPE });
        }
        dispatch(getUsersData(""));
        dispatch(getAllTenantLocationData())
    }, []);

    useEffect(() => {
        const authUser = localStorage.getItem("authUser");
        if (authUser) {
            const authUserObj = JSON.parse(authUser);
            setUserDetails(authUserObj)
            setname(authUserObj.username);
            setemail(authUserObj.email);
            setidx(authUserObj.userId);

            // setTimeout(() => {
            //     dispatch(resetProfileFlag());
            // }, 3000);
        }
    }, [roleData]);

    useEffect(() => {
        setManagerInfo( Array.isArray(settings_users_data.content)
            ? settings_users_data.content.map((user) => ({
                label: `${user.firstName} ${user.lastName}`,
                value: user.id.toString(),
                id: user.id,
                version: user.version,
            })) : [])
    }, [settings_users_data]);


    useEffect(() => {
        const newLocation = tenant_all_location_data?.content?.map(location => ({
            value: location.id,
            label: location.name,
            id: location.id,
        })) || [];

        const addNewItem = {
            value: 'add_new',
            label: 'Add New',
        };
        console.log(tenant_all_location_data);
        setLocation([...newLocation, addNewItem]);
    }, [tenant_all_location_data]);

    const { error, success } = useSelector(state => ({
        error: state.Profile.error,
        success: state.Profile.success,
    }))

    const userProfileValidation = useFormik({
        enableReinitialize: true,
        initialValues: {
            idx: idx || '',
            firstName: userDetails?.name ? userDetails.name.split(" ")[0] || "" : "",
            lastName: userDetails?.name ? userDetails.name.split(" ")[1] || "" : "",
            email:  userDetails.email,
            roles:  userDetails.roles || [],
            phoneNumber: "",
            password:  "",
            reEnterdPassword:  "",
            roleNames: "",
            manager:  "",
            location: "",
            purviewType: userDetails.purviewType,
            discountPurview: userDetails.discountPurview
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .required("Password is required"),

            reEnterdPassword: Yup.string()
                .oneOf([Yup.ref("password"), null], "Passwords must match")
                .required("Confirm Password is required"),
        }),
        onSubmit: (values) => {
            console.log(values);
            const payload = {
                email: values.email,
                password: values.password,
            };
            dispatch(passwordChangeRequest(payload));
        }
    });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Account" breadcrumbItem="Profile" />

          <Row>
            <Col lg="12">
              {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">{success}</Alert> : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center ms-3">
                      <div className="text-muted">
                        <h5>{name}</h5>
                        <p className="mb-1">{email}</p>
                        <p className="mb-0">Id no: #{idx}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Card>
            <CardBody>
              <form>
                <Input name="idx" value={idx} type="hidden" />
                <Row>
                  <Col lg="12">
                      <div className="row">
                          {/* First name */}
                          <div className="col-md-6 col-lg-4 mb-4">
                              <label className="form-label">First Name<span className='required_star'>*</span></label>
                              <div className="">
                                  <Input
                                      disabled={true}
                                      type="text"
                                      name="firstName"
                                      id="firstName"
                                      value={userProfileValidation.values.firstName}
                                      onChange={userProfileValidation.handleChange}
                                      onBlur={userProfileValidation.handleBlur}
                                      className="form-control"
                                      placeholder="Enter First Name"
                                      invalid={userProfileValidation.touched.firstName && userProfileValidation.errors.firstName ? true : false}
                                  />
                                  {userProfileValidation.touched.firstName && userProfileValidation.errors.firstName ? (
                                      <FormFeedback> {userProfileValidation.errors.firstName} </FormFeedback>
                                  ) : null}
                              </div>
                          </div>

                          {/* Last name */}
                          <div className="col-md-6 col-lg-4 mb-4">
                              <label className="form-label">Last Name</label>
                              <div className="">
                                  <Input
                                      disabled={true}
                                      type="text"
                                      name="lastName"
                                      id="lastName"
                                      value={userProfileValidation.values.lastName}
                                      onChange={userProfileValidation.handleChange}
                                      className="form-control"
                                      placeholder="Enter Last Name"
                                  />
                              </div>
                          </div>

                          {/* Email */}
                          <div className="col-md-6 col-lg-4 mb-4">
                              <label className="form-label">Email Id<span className='required_star'>*</span></label>
                              <div className="">
                                  <Input
                                      disabled={true}
                                      type="text"
                                      name="email"
                                      id="email"
                                      value={userProfileValidation.values.email}
                                      onChange={userProfileValidation.handleChange}
                                      onBlur={userProfileValidation.handleBlur}
                                      className="form-control"
                                      placeholder="Enter Email id"
                                      invalid={userProfileValidation.touched.email && userProfileValidation.errors.email ? true : false}
                                  />
                                  {userProfileValidation.touched.email && userProfileValidation.errors.email ? (
                                      <FormFeedback> {userProfileValidation.errors.email} </FormFeedback>
                                  ) : null}
                              </div>
                          </div>
                      </div>

                      <div className="row">
                          {/* Select Role */}
                          <div className="col-md-6 col-lg-4 mb-4">
                              <label className="form-label">Phone Number<span className='required_star'>*</span></label>
                              <div className="">
                                  <Input
                                      disabled={true}
                                      type="text"
                                      name="phoneNumber"
                                      id="phoneNumber"
                                      value={userProfileValidation.values.phoneNumber}
                                      onChange={userProfileValidation.handleChange}
                                      onBlur={userProfileValidation.handleBlur}
                                      className="form-control"
                                      placeholder="Enter Phone Number...."
                                      invalid={userProfileValidation.touched.phoneNumber && userProfileValidation.errors.phoneNumber ? true : false}
                                  />
                                  {userProfileValidation.touched.phoneNumber && userProfileValidation.errors.phoneNumber ? (
                                      <FormFeedback> {userProfileValidation.errors.phoneNumber} </FormFeedback>
                                  ) : null}
                              </div>
                              {/*<div className="">*/}
                              {/*    <Select*/}
                              {/*        isDisabled={true}*/}
                              {/*        value={roleData?.filter((role) => userProfileValidation.values.roles.includes(role.value))}*/}
                              {/*        onChange={(selectedOptions) => {*/}
                              {/*            console.log(selectedOptions, "selectedOptions roles");*/}
                              {/*            //const selectedValues = selectedOptions.map((option) => option.id);*/}
                              {/*            //userProfileValidation.setFieldValue("roles", selectedValues);*/}
                              {/*        }}*/}
                              {/*        name="roles"*/}
                              {/*        id="roles"*/}
                              {/*        options={roleData}*/}
                              {/*        onBlur={userProfileValidation.handleBlur}*/}
                              {/*        isMulti*/}
                              {/*        placeholder="Select Role"*/}
                              {/*        classNamePrefix="select2-selection form-select"*/}
                              {/*        invalid={userProfileValidation.touched.roles && userProfileValidation.errors.roles ? true : false}*/}
                              {/*        autoComplete="off"*/}
                              {/*    />*/}
                              {/*    {userProfileValidation.touched.roles && userProfileValidation.errors.roles ? (*/}
                              {/*        <FormFeedback> {userProfileValidation.errors.roles} </FormFeedback>*/}
                              {/*    ) : null}*/}
                              {/*</div>*/}
                          </div>

                          {/* Password */}
                          <div className="col-md-6 col-lg-4 mb-4">
                              <label className="form-label">Enter Password<span className='required_star'>*</span></label>
                              <div id="enterPasswordArea" className="input-group auth-pass-inputgroup">
                                  <Input
                                      type={passwordShow ? "text" : "password"}
                                      name="password"
                                      id="password"
                                      value={userProfileValidation.values.password}
                                      onChange={userProfileValidation.handleChange}
                                      onBlur={userProfileValidation.handleBlur}
                                      className="form-control"
                                      placeholder="Enter Password"
                                      invalid={userProfileValidation.touched.password && userProfileValidation.errors.password ? true : false}
                                  />
                                  <button onClick={() => setPasswordShow(!passwordShow)} className={`btn btn-light shadow-none ms-0 ${passwordShow ? 'show' : ''}`} type="button" id="onboarding-password-addon"></button>
                                  {userProfileValidation.touched.password && userProfileValidation.errors.password ? (
                                      <FormFeedback> {userProfileValidation.errors.password} </FormFeedback>
                                  ) : null}
                              </div>
                          </div>

                          {/* Re-Enter Password */}
                          <div className="col-md-6 col-lg-4 mb-4">
                              <label className="form-label"> Re-Enter Password<span className='required_star'>*</span></label>
                              <div className="">
                                  <Input
                                      type="password"
                                      name="reEnterdPassword"
                                      id="confirmpassword"
                                      value={userProfileValidation.values.reEnterdPassword}
                                      onChange={userProfileValidation.handleChange}
                                      onBlur={userProfileValidation.handleBlur}
                                      className="form-control"
                                      placeholder="Re-Enter Password"
                                      invalid={userProfileValidation.touched.reEnterdPassword && userProfileValidation.errors.reEnterdPassword ? true : false}
                                      autoComplete="off"
                                  />
                                  {userProfileValidation.touched.reEnterdPassword && userProfileValidation.errors.reEnterdPassword ? (
                                      <FormFeedback> {userProfileValidation.errors.reEnterdPassword} </FormFeedback>
                                  ) : null}
                              </div>
                          </div>

                          {/* Manager */}
                          {/*<div className="col-md-6 col-lg-3 mb-4">*/}
                          {/*    <label className="form-label">Manager</label>*/}
                          {/*    <div className="">*/}
                          {/*        <Select*/}
                          {/*            isDisabled={true}*/}
                          {/*            name="manager"*/}
                          {/*            id="manager"*/}
                          {/*            value={userProfileValidation.values.manager}*/}
                          {/*            onChange={(e) => { userProfileValidation.setFieldValue("manager", e); }}*/}
                          {/*            onBlur={userProfileValidation.handleBlur}*/}
                          {/*            options={managerInfo}*/}
                          {/*            placeholder="Select Employee"*/}
                          {/*            classNamePrefix="select2-selection form-select"*/}
                          {/*            invalid={userProfileValidation.touched.manager && userProfileValidation.errors.manager ? true : false}*/}
                          {/*        />*/}
                          {/*    </div>*/}
                          {/*</div>*/}

                          {/* Location */}
                          {/*<div className="col-md-6 col-lg-3 mb-4">*/}
                          {/*    <label className="form-label">Location</label>*/}
                          {/*    <div className="">*/}
                          {/*        <Select*/}
                          {/*            isDisabled={true}*/}
                          {/*            name="location"*/}
                          {/*            id="location"*/}
                          {/*            value={locations ? locations.find((option) => option.value === userProfileValidation.values.location) || "" : ""}*/}
                          {/*            onChange={(e) => {*/}
                          {/*                if (e.label == "Add New") {*/}
                          {/*                    navigate("/Settings/AddTanentLocation")*/}
                          {/*                } else {*/}
                          {/*                    userProfileValidation.setFieldValue("location", e.value);*/}
                          {/*                }*/}
                          {/*            }}*/}
                          {/*            onBlur={userProfileValidation.handleBlur}*/}
                          {/*            options={locations}*/}
                          {/*            placeholder={"Select locations"}*/}
                          {/*            classNamePrefix="select2-selection form-select"*/}
                          {/*            invalid={userProfileValidation.touched.location && userProfileValidation.errors.location ? true : false}*/}
                          {/*        />*/}
                          {/*    </div>*/}
                          {/*</div>*/}
                          {/*<div className=" row col-md-6 col-lg-3 mb-4">*/}
                          {/*    <label className="form-label">  Purview Type <span className='required_star'>*</span></label>*/}
                          {/*    <div >*/}
                          {/*        <Select*/}
                          {/*            isDisabled={true}*/}
                          {/*            value={optionMarkupType && optionMarkupType.find(obj => obj.value === userProfileValidation.values.purviewType)}*/}
                          {/*            name='purviewType'*/}
                          {/*            onChange={(e) => { userProfileValidation.setFieldValue("purviewType", e.value); }}*/}
                          {/*            options={optionMarkupType}*/}
                          {/*            //isDisabled={roleData?.filter(data => data.value === "PRICING_TEAM" || data.value === "TENANT_SALES_MANAGER").some(role => userProfileValidation.values.roles.includes(role.id))}*/}
                          {/*            classNamePrefix="select2-selection form-select"*/}
                          {/*            menuPlacement="auto"*/}
                          {/*        />*/}
                          {/*    </div>*/}
                          {/*</div>*/}
                          {/*<div className="row col-md-6 col-lg-3 mb-4">*/}
                          {/*    <label className="form-label"> Discount <span className='required_star'>*</span></label>*/}
                          {/*    <div >*/}
                          {/*        <Input*/}
                          {/*            disabled={true}*/}
                          {/*            type="number"*/}
                          {/*            name="discountPurview"*/}
                          {/*            id="discountPurview"*/}
                          {/*            value={userProfileValidation.values.discountPurview}*/}
                          {/*            onChange={userProfileValidation.handleChange}*/}
                          {/*            onBlur={userProfileValidation.handleBlur}*/}
                          {/*            isDisabled={roleData?.filter(data => data.value === "PRICING_TEAM" || data.value === "TENANT_SALES_MANAGER").some(role => userProfileValidation.values.roles.includes(role.id))}*/}
                          {/*            className="form-control"*/}
                          {/*            placeholder="Enter Discout "*/}
                          {/*            invalid={userProfileValidation.touched.discountPurview && userProfileValidation.errors.discountPurview ? true : false}*/}
                          {/*        />*/}
                          {/*        {userProfileValidation.touched.discountPurview && userProfileValidation.errors.discountPurview ? (*/}
                          {/*            <FormFeedback> {userProfileValidation.errors.discountPurview} </FormFeedback>*/}
                          {/*        ) : null}*/}
                          {/*    </div>*/}
                          {/*</div>*/}
                      </div>
                      <div className="text-center mt-4">
                          <Button type="submit" color="danger" onClick={userProfileValidation.handleSubmit}>
                              Update Profile
                          </Button>
                      </div>
                  </Col>
                </Row>

              </form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserProfile);
